import {createStore} from 'effector';

export const $unpublishedList = createStore([])

export const $rejectModal = createStore(null)

export const $rejectStatus = createStore(false)